"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeRedirectTo = void 0;
var error_1 = require("../../build-babel/logger/error");
var makeRedirectTo = function makeRedirectTo(redirectUrl) {
  (0, error_1.removeErrorLogger)();
  window.location.replace(redirectUrl);
};
exports.makeRedirectTo = makeRedirectTo;
//# sourceMappingURL=redirect.js.map